import { FileInfo } from "./FileCenter";

export default class FileFailedRecord {
  
    constructor(public fileInfo: FileInfo, public log: string) {
        this.fileInfo = fileInfo;
        this.log = log;
    }
}